export default __webpack_public_path__ + "static/media/bg_weedigital_page.38be1025.png";